export default "__VITE_ASSET__7WI3LVi6__"